
import _ from 'lodash';
import { types as profileActionTypes } from 'redux/actions/profile';
import { types as sessionActionTypes } from 'redux/actions/session';

const initialState = {
  collection: [],
  isFetching: false,
};

export function reducer(state = initialState, action = {}) {
  let existingCollection = state.collection;
  const payload = action.payload;

  switch (action.type) {
    case sessionActionTypes.LOG_OUT:
      return Object.assign({}, initialState);
    case profileActionTypes.RECEIVE:
      existingCollection = existingCollection.filter((c) => c.id !== payload.profile.id);
      existingCollection.push(payload.profile);
      return Object.assign({}, state, {
        isFetching: false,
        collection: existingCollection,
      });
    case profileActionTypes.REQUEST:
    default:
      return state;
  }
}

const selectors = {
  get: (state, profileId) => state.lists.profile.collection.filter(p => p.id === profileId)[0] || {},
};

export default selectors;
